<script>
  import { OTHER } from '../colors.js';
  import { intcomma } from 'journalize';

  /** @type {string} */
  export let name;
  /** @type {string} */
  export let color;
  /** @type {string} */
  export let party;
  /** @type {number} */
  export let votes;
  /** @type {string} */
  export let votePercent;
  /** @type {boolean} */
  export let includeParty;
</script>

<tr class="candidate contest__candidate-row">
  <th scope="row" class="candidate__cell candidate__cell-name text-regular">
    <span
      class="circle-pill"
      style="background-color: {color}; color: {color};"
    />
    <span class="text-bold">{name}</span>
  </th>
  {#if includeParty}
    <td class="candidate__cell candidate__cell-votes text-left">
      {party ? party.toUpperCase() : ''}
    </td>
  {/if}
  <td class="candidate__cell candidate__cell-votes text-right">
    {intcomma(votes)}
  </td>
  <td class="candidate__cell candidate__cell-pct text-right">{votePercent}</td>
</tr>
